var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tx-export" },
    [
      _c(
        "md-button",
        {
          staticClass: "tx-export__btn btn md-primary md-yellow",
          attrs: { type: "button" },
          on: { click: _vm.openPopup }
        },
        [_vm._v("\n    " + _vm._s(_vm.i18n.th_export_btn()) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          staticClass: "tx-export-popup__wrap",
          attrs: { "md-backdrop": true, "md-active": _vm.isPopup },
          on: {
            "update:mdActive": function($event) {
              _vm.isPopup = $event
            },
            "update:md-active": function($event) {
              _vm.isPopup = $event
            }
          }
        },
        [_c("tx-export-popup", { on: { close: _vm.closePopup } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb9a95ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb9a95ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/components/TxExport.vue
// module id = QMd5
// module chunks = 1